export default "__VITE_ASSET__b7021308__"